const PLAYERTRACK_TYPE = {
    ALBUM: 'album',
    PLAYLIST: 'playlist',
    SONG: 'song',
    ARTIST: 'artist',
    RADIO: 'radio'
};

module.exports = PLAYERTRACK_TYPE;



// WEBPACK FOOTER //
// ./src/containers/Music/playerTracksType.js